<section>
  <app-breadcrumb [label]="label" class="w-full"></app-breadcrumb>

  <div class="section__main section__main--commissions">
    <div class="section__title section__title--mb">
      <h1>
        Mis tiendas
      </h1>
    </div>

    <div class="commission__block">
      <p-accordion class="w-full" [activeIndex]="0" (onOpen)="onChangeTab($event)" expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
        <p-accordionTab *ngFor="let sale of listStores" iconPos="end">
          <ng-template pTemplate="header">
            <div class="accordion-header">
              <i class="pi pi-map-marker"></i>
              <span>{{ sale.name }}</span>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <div class="commission__title">
              <h2>Ventas</h2>
            </div>
            <p-table [value]="listSaleOneStore" styleClass="p-datatable" id="table_stores">
              <ng-template pTemplate="header">
                <tr>
                  <th>Hoy</th>
                  <th>Semana</th>
                  <th class="text-left">Mes</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-sale>
                <tr>
                  <td>
                    <div class="datatable__generalText">
                      <p>{{sale.today}}</p>
                    </div>
                  </td>
                  <td>
                    <div class="datatable__generalText">
                      <p>{{sale.week}}</p>
                    </div>
                  </td>
                  <td>
                    <div class="datatable__generalText text-left">
                      <p>{{sale.month}}</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="summary">
                <div class="datatable__footerText datatable__footerText--background text-center">
                  <p>Comisiones acumuladas: <strong class="highlight">{{ this.commissionStore | currency}}</strong></p>
                </div>
              </ng-template>
            </p-table>
          </ng-template>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
</section>
